import React, { useContext } from "react";
import { useNavigate } from "react-router-dom";
import Button, { Icons } from "../buttons/Button";
import { ReactComponent as LogoutIcon } from "../../assets/icons/logout.svg";
import AuthContext from "../../store/authContext";
import OrgContext from "../../store/orgContext";
import { AUTH_TRANSLATIONS } from "../../translations/util";

const ProfileDropdown = () => {
  const [isOpen, setIsOpen] = React.useState(false);
  const { name, logout: logoutHandler } = useContext(AuthContext);
  const { updateOrg } = useContext(OrgContext);
  const navigate = useNavigate();

  const logout = () => {
    logoutHandler();
    updateOrg(null);
    navigate(`/`);
  };

  return (
    <>
      <Button
        data-dropdown-toggle="profile-dropdown"
        kind="ghost"
        className="profile-icon"
        icon={Icons.Profile}
        onClick={() => setIsOpen(!isOpen)}
      />
      {isOpen ? (
        <div className="profile-dropdown">
          <div className="admin-details">
            <div className="user-details">
              {/* {" "} */}
              {name}
              {/* <span>Admin</span>{" "} */}
            </div>
            {/* <div className="user-email">jane.cooper@abc.com</div> */}
          </div>
          <ul className="dropdown-options">
            <li className="dropdown-item">
              <button type="button" onClick={logout} className="option-item">
                <span className="option-icon">
                  <LogoutIcon />
                </span>
                <span style={{ color: "#781C1C" }} className="option-text">
                  {AUTH_TRANSLATIONS.btnLabels.logOut}
                </span>
              </button>
            </li>
          </ul>
        </div>
      ) : null}
    </>
  );
};
export default ProfileDropdown;
